import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ToastContainer } from "react-toastify";

import { IntelligemsThemeProvider } from "@intelligems/ig-theme/theme";
import { StyledEngineProvider } from "@mui/material/styles";
import { queryClient } from "@src/queryClient";
import store from "@src/store";
import { theme } from "@src/theme";
import { QueryClientProvider } from "@tanstack/react-query";

import "react-toastify/dist/ReactToastify.css";

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReduxProvider store={store}>
        <StyledEngineProvider injectFirst>
          <IntelligemsThemeProvider theme={theme}>
            <ToastContainer
              aria-label="Notifications"
              closeOnClick={true}
              autoClose={5000}
            />
            {children}
          </IntelligemsThemeProvider>
        </StyledEngineProvider>
      </ReduxProvider>
    </QueryClientProvider>
  );
};
